import { toast } from '@systemeio/ui'
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useSendNewsletter = () => {
  const { t } = useLocoTranslation()
  const { fetcher } = useFetch({
    method: RequestMethodsEnum.post,
  })
  return {
    fetcherSendNewsletter: async (id: NewsletterId) => {
      try {
        await fetcher(`${NEWSLETTERS_API}/send/${id}`)
        toast.success(t('dashboard.newsletter_editor.was_sent_message'))
      } catch (e) {
        throw e
      }
    },
  }
}
